import { t } from "@/lib/i18n";
import { useState } from "react";
import { FolderSearch, Search, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { CaseCard } from "./CaseCard";

export const CasesSheet = ({ open, setOpen, casesApi }) => {
  const [folio, setFolio] = useState("");
  const [busy, setBusy] = useState(false);

  const find = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await casesApi.lookup(folio);
      setFolio("");
    } catch (err) {
      toast.error(t("cases.notFound"));
    }
    setBusy(false);
  };

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent data-testid="cases-sheet" className="w-full overflow-y-auto bg-ac-bg font-body sm:max-w-md">
        <SheetHeader className="text-left">
          <SheetTitle className="font-display text-2xl text-ac-ink">{t("cases.title")}</SheetTitle>
          <SheetDescription>{t("cases.desc")}</SheetDescription>
        </SheetHeader>
        <form onSubmit={find} className="mt-5 flex gap-2">
          <input data-testid="case-lookup-input" value={folio} onChange={(e) => setFolio(e.target.value.toUpperCase())} placeholder={t("cases.search")} className="h-11 flex-1 rounded-xl border border-ac-line px-3 font-mono text-sm outline-none focus:border-ac-primary" />
          <button data-testid="case-lookup-button" disabled={!folio.trim() || busy} className="grid h-11 w-11 place-items-center rounded-xl bg-ac-strong text-white disabled:opacity-40">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Search className="h-4 w-4" />}
          </button>
        </form>
        <div className="mt-5 space-y-3">
          {casesApi.cases.length === 0 ? (
            <div data-testid="cases-empty" className="rounded-2xl border border-dashed border-ac-line2 bg-ac-surface p-8 text-center">
              <FolderSearch className="mx-auto h-8 w-8 text-ac-faint" />
              <p className="mt-3 text-sm font-medium text-ac-text">{t("cases.emptyT")}</p>
              <p className="text-xs text-ac-muted">{t("cases.emptyS")}</p>
            </div>
          ) : (
            casesApi.cases.map((c) => <CaseCard key={c.folio} c={c} onUpdate={casesApi.updateStatus} onSetAppointment={casesApi.setAppointment} onForget={casesApi.forget} />)
          )}
        </div>
      </SheetContent>
    </Sheet>
  );
};
